module.exports = {
      id: "chevron-rounded-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "img/symbols.b783b922d187f028e7dcd3736258c276.svg#chevron-rounded",
      toString: function () {
        return this.url;
      }
    }